import React from 'react';
import {connect} from 'react-redux'
import swal from 'sweetalert'
import AccountRowEdit from './AccountRowEdit'

import {
  lock_account,
  activate_account,
  destroy_account,
  reset_account_errors
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    lockAccount: (account_id) => dispatch( lock_account(account_id) ),
    activateAccount: (account_id) => dispatch( activate_account(account_id) ),
    destroyAccount: (account_id, page) => dispatch( destroy_account(account_id, page) ),
    resetErrors: () => dispatch( reset_account_errors() )
  }
}

class ConnectedAccountRow extends React.Component {

  initEdit() {
    const {id} = this.props.account
    this.props.resetErrors()
    this.props.initEdit(id)
  }

  cancel() {
    this.props.initEdit(null)
  }

  lockAccount() {
    const {account, lockAccount} = this.props
    const {id} = account
    lockAccount(id)
  }

  activateAccount() {
    const {account, activateAccount} = this.props
    const {id} = account
    activateAccount(id)
  }

  destroyAccount() {
    const {account, page, destroyAccount} = this.props
    const {id} = account
    destroyAccount(id, page)
  }

  render() {
    const {account, current_user, currentEdit } = this.props
    const {id, name, description, active, users, projects, user_analysis, project_analysis } = account;

    let iconTitle, activeIcon
    if (active) {
      iconTitle = 'Account is active'
      activeIcon = <i className="material-icons c-light-green">power</i>
    } else {
      iconTitle = 'Account is administravely deactivated'
      activeIcon = <i className="material-icons c-red">power_off</i>
    }

    const editLink = (
      <a href="" className="action-btn" title="Edit" onClick={ e=> {
        e.preventDefault()
        this.initEdit()
      }}><i className="material-icons tiny c-light-green">create</i></a>
    )

    const enableLink = (active) ? "" : (
      <a href="" className="action-btn" title="Reactivate" onClick={ e=> {
        e.preventDefault()
        this.activateAccount()
      }}><i className="material-icons tiny c-light-green">power</i></a>
    )

    const disableLink = (!active || current_user.account.id === id ) ? "" : (
      <a href="" className="action-btn" title="Deactivate" onClick={ e=> {
        e.preventDefault()
        this.lockAccount()
      }}><i className="material-icons tiny c-yellow">power_off</i></a>
    )

    const delLink = (current_user.account.id === id) ? '' : (
      <a href="" className="action-btn" title="Delete" onClick={ e=> {
        e.preventDefault()
        swal({
          title: "Delete account?",
          text: `Are you sure that you want to delete account ${name}?\nAll related users and projects will be irreversibly deleted.`,
          icon: "error",
          buttons: [true, true ],
          dangerMode: true
        }).then(willDelete => {
          if (willDelete) {

            swal({
              title: "Final Warning!",
              text: `This action is IRREVERSIBLE\nAre you absolutely sure that you want to delete account ${name}?\nAll related users and projects will be deleted.\nType OK below to permanently delete ${name}.`,
              content: "input",
              icon: "error",
              buttons: [true, true ],
              dangerMode: true
            }).then( value => {
              if ( value !== undefined ) {
                const typed = value.toLowerCase()
                if (typed === "ok") {
                  this.destroyAccount()
                }
              }
            })
          }
        });
      }}><i className="material-icons tiny c-red">delete_forever</i></a>
    )

    const showRow = (currentEdit !== id) ? "" : "hide"
    const disabledClass = ( active ) ? "" : "accountDisabled"
    const showForm = (currentEdit === id) ? "" : "hide"
    const descriptionHTML = (description === undefined || description === null || description.trim === '') ? '' : <pre className="feedUrl c-darkgrey">{description}</pre>


    return (
      <React.Fragment>
        <tr className={`${showRow} ${disabledClass}`.trim()}>
          <td>
            <div className="view">{ name }</div>
            { descriptionHTML }
          </td>
          <td title={iconTitle}>
            { activeIcon }
          </td>
          <td>
            <small><p>{user_analysis.user} users</p></small>
            <small><p>{user_analysis.manager} managers</p></small>
            <small><p>{user_analysis.admin} admins</p></small>
            <small><p>{users} total</p></small>
          </td>
          <td>
            <small><p>{project_analysis.active} active</p></small>
            <small><p>{project_analysis.inactive} inactive</p></small>
            <small><p>{projects} total</p></small>
          </td>
          <td>
            { editLink }
            { enableLink }
            { disableLink }
            { delLink }
          </td>
        </tr>

        <AccountRowEdit account={account} current_user={current_user} showForm={showForm} cancel={this.cancel.bind(this)}/>

      </React.Fragment>
    )

  }
}

const AccountRow = connect(null, mapDispatchToProps)(ConnectedAccountRow)
export default AccountRow



// WEBPACK FOOTER //
// ./src/js/components/AccountRow.js